import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SafeBox } from 'src/app/api/api-campaigns.service.generated';
import { environment } from 'src/environments/environment';
import { MatDialogModule } from '@angular/material/dialog';
import { ButtonComponent } from 'wecheer-common';

@Component({
  selector: 'app-universal-code',
  templateUrl: './universal-code.component.html',
  styleUrls: ['./universal-code.component.scss'],
  imports: [
    MatDialogModule,
    ButtonComponent
  ]
})
export class UniversalCodeComponent implements OnInit {
  safeBox = inject<SafeBox>(MAT_DIALOG_DATA);

  isCopied = false;
  safeBoxUrl: string;

  ngOnInit() {
    this.safeBoxUrl = environment.loyaltyAppUrl + '/sb/' + this.safeBox.code;
  }

  onCopySafeBoxUrl() {
    navigator.clipboard.writeText(this.safeBoxUrl).then(() => {
      this.isCopied = true;
    });
  }
}
